import React from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import loadable from '@loadable/component';

import {
    isUserLoggedIn,
    shouldHideLogin,
} from '~shared/utils/user';
import {
    openLoginModal,
} from '~spa/Utils/WrapperIntegration/Ucf';

const MyBetsTabs = loadable(
    () => import(
        /* webpackChunkName: "my-bets-tabs" */
        '~legacy/modules/jsx/bethistory/app/components/nav/MyBetsTabs'
    )
);

const MyBetsPage = () => {
    const [ t ] = useTranslation();
    const showLogin = !shouldHideLogin();

    const loginOpenBets = () => {
        const loginClass = classNames({
            'fullslip__login-link': showLogin,
        });

        return (
            <div className="fullslip__open-bets-login">
                <span
                    className={loginClass}
                    onClick={() => {
                        if (showLogin) {
                            openLoginModal();
                        }
                    }}
                >{t('betslip.login')}</span>
                <span>{t('betslip.see_open_bets')}</span>
            </div>
        );
    };

    return (
        <div className="fullslip__content">
            {
                isUserLoggedIn()
                ? <MyBetsTabs />
                : loginOpenBets()
            }
        </div>
    );
};

export default MyBetsPage;
